<!-- https://www.smashingmagazine.com/2022/03/drag-drop-file-uploader-vuejs-3/ -->
<!-- https://codepen.io/incentive/details/mdwoVqO -->
<template>

   <div class="fileInput">
      <div class="fileUploadDropZone" :class="{ 'activeZone': isActive }" @drop.prevent="onDrop"
         @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive">
         <p class="mt-2">Drag and drop <span v-if="maxUploadItems == 1">a</span> file<span
               v-if="maxUploadItems > 1">s</span> here</p>
         <p class="mt-2">or</p>
         <input type="file" ref="filesRef" :id="id" class="position-absolute invisible" multiple
            v-on:change="onInputChange" :accept="acceptedFileTypeList.toString()" />
         <label class="btn btn-info text-light" :for="id">Choose <span v-if="maxUploadItems == 1">a</span> file<span
               v-if="maxUploadItems > 1">(s)</span></label>
      </div>

      <div class="fileList mx-2" v-show="fileList.length > 0">
         <div v-for="file of fileList" :key="file.id" class="p-1">
            <div>
               <span class="p-2">{{ file.name }}</span>
               <span class="removeFile" @click="removeFile(file, $event)" title="Click to remove file"><i
                     class="fa-solid fa-xmark fa-xs"></i></span>
            </div>
         </div>
      </div>

      <div v-if="isInvalidFile">
         <div v-for="file of invalidFiles" :key="file.id" class="p-1">
            <span class="p-2 small text-danger">Invalid file: {{ file.name }} </span>
         </div>
      </div>

      <div v-if="isDuplicateFile">
         <div v-for="file of duplicateFiles" :key="file.id" class="p-1">
            <span class="p-2 small text-danger">Duplicate file: {{ file.name }} </span>
         </div>
      </div>

      <div v-if="isFileNotAccepted">
         <span class="p-2 small text-danger"><strong>File/s not accepted:</strong></span>
         <div v-for="file of notAcceptedFiles" :key="file.id" class="p-1">
            <span class="p-2 small text-danger"> {{ file.name }} </span>
         </div>
      </div>
   </div>


</template>

<script>


const events = ['dragenter', 'dragover', 'dragleave', 'drop']

export default ({

   props: {
      id: {
         type: String
      },

      acceptedFileType: {
         type: String, //each type must be separated by comma
         default: ""
      },

      maxUploadItems: {
         type: Number,
         default: 100
      },

      maxUploadMBSize: {
         type: Number,
         default: 40000000
      },

   },

   emits: ['fileListChange'],

   data() {
      return {
         isActive: false,
         inactiveTimeout: null,
         fileList: [], //for viewing purposes
         convertedFileList: [], //converted to base64 files, will be passed to parent component
         isDuplicateFile: false,
         duplicateFiles: [],
         acceptedFileTypeList: [],
         isFileNotAccepted: false,
         notAcceptedFiles: [],
         isInvalidFile: false,
         invalidFiles: [],
      }
   },

   mounted() {
      events.forEach((eventName) => {
         document.body.addEventListener(eventName, this.preventDefaults)
      })

      if (this.acceptedFileType != "") {
         this.mapAcceptedFileTypes()
      }

   },

   unmounted() {
      events.forEach((eventName) => {
         document.body.removeEventListener(eventName, this.preventDefaults)
      })
   },

   methods: {

      preventDefaults(e) {
         e.preventDefault()
      },

      onDrop(e) {
         this.setInactive()
         this.addFiles(e.dataTransfer.files)
      },

      setActive() {
         this.isActive = true
         clearTimeout(this.inactiveTimeout)
      },

      setInactive() {
         this.inactiveTimeout = setTimeout(() => {
            this.isActive = false
         }, 50)
      },

      onInputChange(e) {
         this.addFiles(e.target.files)
         e.target.value = null
      },

      addFiles(files) {

         let fileSize = 0
         for (let i = 0; i < files.length; i++) {
            fileSize += files[i].size
         }

         if (fileSize > this.maxUploadMBSize) {
            this.$toast.error(`You can upload a total of ${this.maxUploadMBSize / 1000000} MB only. Uploaded file is ${fileSize / 1000000} MB.`)
            return
         }

         if (files.length > this.maxUploadItems) {

            if (this.maxUploadItems == 1) {
               this.$toast.error(`Please upload ${this.maxUploadItems} file only.`)
            } else if (this.maxUploadItems > 1) {
               this.$toast.error(`Please upload ${this.maxUploadItems} files only.`)
            }
            return
         }

         if (this.fileList.length >= this.maxUploadItems) {
            if (this.maxUploadItems == 1) {
               this.$toast.error(`Please upload ${this.maxUploadItems} file only.`)
            } else if (this.maxUploadItems > 1) {
               this.$toast.error(`Please upload ${this.maxUploadItems} files only.`)
            }
            return
         }

         for (let i = 0; i < files.length; i++) {
            //validate if file is previously added or the file type is accepted
            if (this.isFileExisting(files[i]) || !this.isFileAccepted(files[i])) {

               if (this.isFileExisting(files[i])) {
                  this.isDuplicateFile = true
                  this.duplicateFiles.push({
                     name: files[i].name
                  })
                  setTimeout(() => {
                     this.isDuplicateFile = false
                     this.duplicateFiles = []
                  }, 2500)
               }

               if (!this.isFileAccepted(files[i])) {
                  this.isFileNotAccepted = true
                  this.notAcceptedFiles.push({
                     name: files[i].name
                  })
                  setTimeout(() => {
                     this.isFileNotAccepted = false
                     this.notAcceptedFiles = []
                  }, 2500)
               }

            } else {

               //will validate if file is valid or not (e.g if file dropped is a folder)
               this.checkIfValidFile(files[i])
                  .then((result) => {
                     try {
                        this.fileList.push(result)
                        this.convertedFileList.push(this.convertFileToBase64(result))
                        // console.log(this.convertedFileList)
                     } catch (error) {
                        console.log("error on compression", error)
                     }
                  })
                  .catch(() => {
                     this.isInvalidFile = true
                     this.invalidFiles.push({
                        name: files[i].name
                     })
                     setTimeout(() => {
                        this.isInvalidFile = false
                        this.invalidFiles = []
                     }, 2500)
                  })

            }

         }

         this.$emit('fileListChange', { type: this.id, files: this.convertedFileList })

      },

      removeFile(file) {
         event.stopPropagation();

         const index = this.fileList.indexOf(file)
         if (index > -1) {
            this.fileList.splice(index, 1)
            this.convertedFileList.splice(index, 1)
         }

         this.$emit('fileListChange', { type: this.id, files: this.convertedFileList })
      },

      convertFileToBase64(file) {
         //convert to base64
         let reader = new FileReader()
         let fileInfo = {}

         let fileName = file.name
         let fileType = file.type
         let extType = fileName.substring(fileName.lastIndexOf('.'));

         reader.readAsDataURL(file);
         reader.onload = () => {
            fileInfo.encoded = reader.result.split(',')[1]
            fileInfo.name = fileName
            fileInfo.extension = extType
            fileInfo.type = fileType

         }

         return fileInfo
      },

      convertFileToBase64_(file) {
         //convert to base64
         let reader = new FileReader()
         let fileInfo = {}

         let fileName = file.name
         let fileType = file.type
         let extType = fileName.substring(fileName.lastIndexOf('.'));

         reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
               const canvas = document.createElement('canvas');
               const ctx = canvas.getContext('2d');

               const maxWidth = 400;
               const maxHeight = 400;
               let width = img.width;
               let height = img.height;

               if (width > maxWidth) {
                  height *= maxWidth / width;
                  width = maxWidth;
               }
               if (height > maxHeight) {
                  width *= maxHeight / height;
                  height = maxHeight;
               }

               canvas.width = width;
               canvas.height = height;
               ctx.drawImage(img, 0, 0, width, height);

               canvas.toBlob((blob) => {
                  return blob;
               }, 'image/jpeg', 0.8);
            };
            img.src = e.target.result;
         }

         reader.readAsDataURL(file);

         console.log(reader.result)
         fileInfo.encoded = reader.result.split(',')[1]
         fileInfo.name = fileName
         fileInfo.extension = extType
         fileInfo.type = fileType

         return fileInfo
      },

      //check if file or folder
      checkIfValidFile(file) {
         return new Promise(function (resolve, reject) {

            const reader = new FileReader()
            reader.onloadend = () => {
               if (reader.error && (
                  reader.error.name === 'NotFoundError' ||
                  reader.error.name === 'NotReadableError')) {
                  return reject(file)
               }
               resolve(file)
            }
            reader.readAsDataURL(file)
         })

      },

      isFileExisting(file) {
         let exists = this.fileList.some((f) => {
            return this.fileInfo(f) == this.fileInfo(file)
         })

         return exists
      },

      isFileAccepted(file) {

         if (this.acceptedFileTypeList.length > 0) {
            let fileType = file.name.substring(file.name.lastIndexOf('.'));

            let isAccepted = this.acceptedFileTypeList.some((type) => {
               return type == fileType
            })

            return isAccepted

         } else {
            return true
         }

      },

      mapAcceptedFileTypes() {
         if (this.acceptedFileType != "") {

            if (this.acceptedFileType.includes(",")) {
               let fileType = this.acceptedFileType.split(",")


               fileType.forEach((type) => {
                  this.acceptedFileTypeList.push("." + type.trim())
               })

            } else {
               this.acceptedFileTypeList.push("." + this.acceptedFileType)
            }

         }
      },

      fileInfo(file) {
         return file.name + "-" + file.size + "-" + file.lastModified + "-" + file.type
      },

      resetForm() {
         this.fileList = []
         this.convertedFileList = []
      },

      compressImage(file) {
         return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
               const img = new Image();
               img.onload = () => {
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');

                  const maxWidth = 400;
                  const maxHeight = 400;
                  let width = img.width;
                  let height = img.height;

                  if (width > maxWidth) {
                     height *= maxWidth / width;
                     width = maxWidth;
                  }
                  if (height > maxHeight) {
                     width *= maxHeight / height;
                     height = maxHeight;
                  }

                  canvas.width = width;
                  canvas.height = height;
                  ctx.drawImage(img, 0, 0, width, height);

                  canvas.toBlob((blob) => {
                     resolve(blob);
                  }, 'image/jpeg', 0.8);
               };
               img.src = e.target.result;
            };
            reader.onerror = reject; // Handle errors
            reader.readAsDataURL(file);
         });
      },
   },

})
</script>

<style scoped>
/* .fileInput {
   background-color: #f4fbff;
} */

.fileUploadDropZone {
   /* color: #fff; */
   outline: 2px dashed #00A0C1;
   outline-offset: -10px;
   transition:
      outline-offset 0.2s ease-out,
      background-color 0.2s ease-out;
   text-align: center;
   padding: 1rem;
}

.activeZone {
   outline-offset: -8px;
   outline-color: #00A0C1;
   background-color: #f5f5f5;
}

.removeFile {
   color: red;
}

.removeFile:hover {
   cursor: pointer;
}

.fileList {
   border: 2px solid #f5f5f5;
   border-radius: 10px;
   /* border-color: #f5f5f5; */
   /* border-width: 2px; */
}
</style>